module.exports = __webpack_public_path__ + "img/aaron_logo.bbb86687.svg";